import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: false,
  loading: false,
  news: [],
};

const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    newsSuccess: (state, { payload }) => {
      state.news = payload
    },
  },
});

export const {newsSuccess} = newsSlice.actions;

export default newsSlice.reducer;
